import React from 'react';

import Field from './Field';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const InputField = ({ name }: { name: string }) => (
  <Field
    name={name}
    renderInput={({ value, id, qaId }) => (
      <input
        id={id}
        name={name}
        value={value || ''}
        data-qa-id={qaId}
        hidden
        readOnly
      />
    )}
    hidden
  />
);

export default InputField;
